import data from './xAxis.data'
import axisLabel from './xAxis.axisLabel'
import axisLine from './xAxis.axisLine'
import axisTick from './xAxis.axisTick'
import splitLine from './xAxis.splitLine'
import splitArea from './xAxis.splitArea'
import axisPointer from './xAxis.axisPointer'
import minorSplitLine from './xAxis.minorSplitLine'
import nameTextStyle from './xAxis.nameTextStyle'
import minorTick from './xAxis.minorTick'

export default {
  name: "xAxis",
  nickname: "X轴",
  desc: "xAxis",
  type: "array",
  props: {
    type: {
      name: "type",
      nickname: "类型",
      desc: "坐标轴类型。",
      value: "category",
      defaultValue: "",
      type: "pureValue",
      eType: "select",
      options: [
        {
          label: "数值轴",
          value: "value",
          desc: "",
        },
        {
          label: "类目轴",
          value: "category",
          desc: "",
        },
        {
          label: "时间轴",
          value: "time",
          desc: "",
        },
        {
          label: "对数轴",
          value: "",
          desc: "",
        },
      ],
    },
    inverse: {
      name: "inverse",
      nickname: "是否是反向坐标轴",
      desc: "是否是反向坐标轴。ECharts 3 中新加。",
      value: false,
      defaultValue: false,
    },
    offset: {
      name: "offset",
      nickname: "偏移",
      desc:
        'X 轴相对于默认位置的偏移，在相同的 <code class="codespan">position</code> 上有多个 X 轴的时候有用。',
      value: 0,
      defaultValue: 0,
    },
    data,
    axisLabel,
    axisLine,
    axisTick,
    splitLine,
    splitArea,
    axisPointer,
    minInterval: {
      name: "minInterval",
      nickname: "最小间隔",
      desc: "自动计算的坐标轴最小间隔大小。",
      value: 0,
      defaultValue: 0,
    },
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示 x 轴。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    position: {
      name: "position",
      nickname: "位置",
      desc: "x 轴的位置。",
    },
    zlevel: {
      name: "zlevel",
      nickname: "图形z水平",
      desc: "X 轴所有图形的 zlevel 值。",
      value: 0,
      defaultValue: 0,
    },
    minorSplitLine,
    name: {
      name: "name",
      nickname: "名称",
      desc: "坐标轴名称。",
    },
    nameLocation: {
      name: "nameLocation",
      nickname: "名称位置",
      desc: "坐标轴名称显示位置。",
      value: "end",
      defaultValue: "end",
      type: "pureValue",
    },
    nameTextStyle,
    nameGap: {
      name: "nameGap",
      nickname: "名称间距",
      desc: "坐标轴名称与轴线之间的距离。",
      value: 15,
      defaultValue: 15,
      type: "pureValue",
    },
    nameRotate: {
      name: "nameRotate",
      nickname: "名称旋转",
      desc: "坐标轴名字旋转，角度值。",
    },
    minorTick,
    boundaryGap: {
      name: "boundaryGap",
      nickname: "坐标轴两边留白策略",
      desc: "坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样。",
    },
    min: {
      name: "min",
      nickname: "最小值",
      desc: "坐标轴刻度最小值。",
    },
    max: {
      name: "max",
      nickname: "最大值",
      desc: "坐标轴刻度最大值。",
    },
    scale: {
      name: "scale",
      nickname: "缩放",
      desc:
        '只在数值轴中（<a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.type">type</a>: &#39;value&#39;）有效。',
      value: false,
      defaultValue: false,
    },
    splitNumber: {
      name: "splitNumber",
      nickname: "分割段数",
      desc:
        "坐标轴的分割段数，需要注意的是这个分割段数只是个预估值，最后实际显示的段数会在这个基础上根据分割后坐标轴刻度显示的易读程度作调整。",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    gridIndex: {
      name: "gridIndex",
      nickname: "gridIndex",
      desc: "x 轴所在的 grid 的索引，默认位于第一个 grid。",
      value: 0,
      defaultValue: 0,
    },
    maxInterval: {
      name: "maxInterval",
      nickname: "最大间隔",
      desc: "自动计算的坐标轴最大间隔大小。",
    },
    interval: {
      name: "interval",
      nickname: "间隔",
      desc: "强制设置坐标轴分割间隔。",
    },
    logBase: {
      name: "logBase",
      nickname: "对数轴底数",
      desc:
        '对数轴的底数，只在对数轴中（<a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.type">type</a>: &#39;log&#39;）有效。',
      value: 10,
      defaultValue: 10,
      type: "pureValue",
    },
    silent: {
      name: "silent",
      nickname: "是否静态",
      desc: "坐标轴是否是静态无法交互。",
      value: false,
      defaultValue: false,
    },
    triggerEvent: {
      name: "triggerEvent",
      nickname: "是否触发事件",
      desc: "坐标轴的标签是否响应和触发鼠标事件，默认不响应。",
      value: false,
      defaultValue: false,
    },
    z: {
      name: "z",
      nickname: "z",
      desc:
        'X 轴组件的所有图形的<code class="codespan">z</code>值。控制图形的前后顺序。<code class="codespan">z</code>值小的图形会被<code class="codespan">z</code>值大的图形覆盖。',
      value: 0,
      defaultValue: 0,
    },
  },
  isExpandForce: true,
  menuIconType: "text",
  menuIcon: "XZ",
}
